import { render, staticRenderFns } from "./DatosEmpresaFormulario.vue?vue&type=template&id=28425829&"
import script from "./DatosEmpresaFormulario.vue?vue&type=script&lang=ts&"
export * from "./DatosEmpresaFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports